import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import faqData from '../data/faq.json';

// Trophées palette (mêmes valeurs que HomePage)
const NAVY = '#1B1E38';
const CYAN = '#39A8E5';
const BLUE = '#4A71E5';
const LIGHT = '#D5DFF0';

export default function FaqPage() {
  const [query, setQuery] = useState('');
  const [openKey, setOpenKey] = useState(null);

  // Filter items by text query (case + accent insensitive)
  const norm = (s) => (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const sections = useMemo(() => {
    const q = norm(query.trim());
    if (!q) return faqData.sections;
    return faqData.sections
      .map((sec) => ({
        ...sec,
        items: sec.items.filter(
          (it) => norm(it.question).includes(q) || norm(it.answer).includes(q),
        ),
      }))
      .filter((sec) => sec.items.length > 0);
  }, [query]);

  const totalCount = useMemo(
    () => faqData.sections.reduce((sum, s) => sum + s.items.length, 0),
    [],
  );

  return (
    <div style={{ minHeight: '100vh', background: 'white' }}>
      {/* ===== Top bar : same shell as the landing page ===== */}
      <header
        style={{
          background: NAVY, color: 'white', padding: '14px 32px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          position: 'sticky', top: 0, zIndex: 100,
        }}
      >
        <Link to="/" style={{ display: 'flex', alignItems: 'baseline', gap: 8, textDecoration: 'none', color: 'white' }}>
          <span style={{ fontFamily: 'Lato, sans-serif', fontWeight: 800, fontSize: 18, letterSpacing: '-0.3px' }}>
            Plateforme ISI
          </span>
          <span style={{ fontFamily: 'Inter, sans-serif', fontWeight: 400, fontSize: 13, color: CYAN }}>
            by Paradoxe.ai for LBP AM
          </span>
        </Link>
        <nav style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <Link to="/faq"
            style={{
              fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
              padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
              color: 'white', background: 'rgba(255,255,255,0.10)',
              border: '1px solid rgba(255,255,255,0.20)', whiteSpace: 'nowrap',
            }}
          >FAQ</Link>
          <a href="mailto:contact.tropheeslbpam@investance-partners.com"
            style={{
              fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
              padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
              color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap',
            }}
          >Nous contacter</a>
          <Link to="/login"
            style={{
              fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
              padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
              color: 'rgba(255,255,255,0.85)', whiteSpace: 'nowrap',
            }}
          >Se connecter</Link>
          <Link to="/register"
            style={{
              fontFamily: 'Lato, sans-serif', fontSize: 14, fontWeight: 600,
              padding: '9px 18px', borderRadius: 999, textDecoration: 'none',
              color: 'white', background: BLUE, border: `1px solid ${BLUE}`, whiteSpace: 'nowrap',
            }}
          >Créer un compte</Link>
        </nav>
      </header>

      {/* ===== Hero ===== */}
      <section style={{
        background: `linear-gradient(180deg, ${NAVY} 0%, #2A2E4E 100%)`,
        color: 'white', padding: '56px 32px 40px',
      }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          <p style={{ fontSize: 13, color: CYAN, fontWeight: 600, letterSpacing: 1.2, marginBottom: 12, textTransform: 'uppercase' }}>
            Foire aux questions
          </p>
          <h1 style={{ fontFamily: 'Lato, sans-serif', fontSize: 38, fontWeight: 800, lineHeight: 1.15, marginBottom: 12, marginTop: 0 }}>
            Trophées de l'innovation 2026
          </h1>
          <p style={{ fontSize: 16, lineHeight: 1.55, color: 'rgba(255,255,255,0.85)', maxWidth: 720, marginBottom: 28 }}>
            Toutes les réponses aux questions fréquemment posées sur les trophées,
            la candidature, le processus de sélection et le calendrier.
          </p>
          <div style={{ position: 'relative', maxWidth: 540 }}>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="Rechercher une question ou un mot-clé..."
              style={{
                width: '100%', padding: '14px 18px 14px 42px', fontSize: 14,
                border: 'none', borderRadius: 10, outline: 'none', fontFamily: 'inherit',
                boxShadow: '0 4px 20px rgba(0,0,0,0.25)', color: NAVY,
              }}
            />
            <span aria-hidden="true" style={{
              position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)',
              fontSize: 16, color: '#999',
            }}>🔍</span>
          </div>
          {query && (
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.65)', marginTop: 10 }}>
              {sections.reduce((s, sec) => s + sec.items.length, 0)} résultat(s) sur {totalCount}
            </p>
          )}
        </div>
      </section>

      {/* ===== Content ===== */}
      <main style={{ padding: '40px 32px 80px', background: '#F8FAFC' }}>
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
          {sections.length === 0 ? (
            <div style={{
              padding: 40, background: 'white', borderRadius: 12,
              textAlign: 'center', color: '#666', fontSize: 14,
            }}>
              Aucune question ne correspond à votre recherche.
            </div>
          ) : (
            sections.map((sec) => (
              <section key={sec.name} style={{ marginBottom: 32 }}>
                <h2 style={{
                  fontFamily: 'Lato, sans-serif', fontSize: 20, fontWeight: 700,
                  color: NAVY, margin: '0 0 14px',
                  paddingBottom: 8, borderBottom: `2px solid ${LIGHT}`,
                }}>
                  {sec.name}
                </h2>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                  {sec.items.map((item) => {
                    const key = `${sec.name}-${item.num}`;
                    const isOpen = openKey === key;
                    return (
                      <article key={key} style={{
                        background: 'white', borderRadius: 10,
                        border: '1px solid #E5E9F2',
                        boxShadow: isOpen ? '0 6px 24px rgba(27,30,56,0.08)' : 'none',
                        transition: 'box-shadow 0.2s',
                      }}>
                        <button
                          type="button"
                          onClick={() => setOpenKey(isOpen ? null : key)}
                          aria-expanded={isOpen}
                          style={{
                            width: '100%', display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', gap: 16,
                            padding: '16px 20px', background: 'none', border: 'none',
                            cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit',
                          }}
                        >
                          <span style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
                            <span style={{
                              flexShrink: 0,
                              minWidth: 30, height: 30,
                              padding: '0 8px',
                              borderRadius: 999, background: LIGHT,
                              color: NAVY, fontSize: 12, fontWeight: 700,
                              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                              {item.num}
                            </span>
                            <span style={{ fontSize: 15, fontWeight: 600, color: NAVY, lineHeight: 1.35 }}>
                              {item.question}
                            </span>
                          </span>
                          <span aria-hidden="true" style={{
                            fontSize: 18, color: CYAN, flexShrink: 0,
                            transform: isOpen ? 'rotate(180deg)' : 'rotate(0)',
                            transition: 'transform 0.2s',
                          }}>⌄</span>
                        </button>
                        {isOpen && (
                          <div style={{
                            padding: '0 20px 18px 60px', fontSize: 14,
                            lineHeight: 1.6, color: '#333', whiteSpace: 'pre-wrap',
                          }}>
                            {item.answer}
                          </div>
                        )}
                      </article>
                    );
                  })}
                </div>
              </section>
            ))
          )}

          {/* CTA contact en bas de page */}
          <div style={{
            marginTop: 40, padding: 28, borderRadius: 12,
            background: 'white', border: `1px solid ${LIGHT}`,
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap',
          }}>
            <div>
              <div style={{ fontWeight: 700, color: NAVY, fontSize: 16, marginBottom: 4 }}>
                Vous ne trouvez pas votre réponse ?
              </div>
              <div style={{ color: '#555', fontSize: 13 }}>
                Notre équipe répond généralement sous 48 heures ouvrées.
              </div>
            </div>
            <a
              href="mailto:contact.tropheeslbpam@investance-partners.com"
              style={{
                padding: '10px 22px', background: BLUE, color: 'white',
                borderRadius: 999, textDecoration: 'none', fontWeight: 600, fontSize: 14,
              }}
            >
              Nous contacter
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
